import http from "../services/http";

export const apiGetAvailability = async () => {
  try {
    const response = await http.get("/api/doctor/availability");
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const apiUpdateAvailability = async (data) => {
  try {
    const response = await http.put("/api/doctor/availability/update", data);
    return response;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
